import ContentfulApi from "utils/ContentfulApi";

import RenderProductCollection from "components/Reusables/RenderProductCollection";
import { Config } from "utils/Config";

export default function JournalEditionPage(props) {
	let { data, err, additionalData = {} } = props;
	const { journalEdition } = additionalData;

	return (
		<>
			{journalEdition && (
				<div className="px-4 align-items-center d-flex flex-column">
					<h1>{journalEdition.fields.title}</h1>
					<h3>{`Volume ${journalEdition.fields.journalEditionVolume}, Issue ${journalEdition.fields.journalEditionIssue}`}</h3>
				</div>
			)}
			<RenderProductCollection data={additionalData} />
		</>
	);
}

export async function getStaticPaths() {
	const paths = [];

	//get all journals
	let journals = await ContentfulApi.queryIR({
		content_type: "journals",
		except: ["journalEditions"],
	});

	//for each journal, get all editions
	await Promise.all(
		journals.items.map(async (journal, index) => {
			const journalId = journal.sys.id;
			const journalName = journal.fields?.journal[0].toLowerCase();
			//get all journalEditions IDs per journal
			let journalEditions = await ContentfulApi.queryIR({
				content_type: "journalEditions",
				select: "sys.id,fields.editionDate",
				where: {
					links_to_entry: journalId,
				},
			});

			//this is a graphQL query that does the same thing.... //TODO delete unused functions
			// let journalEditions = await ContentfulApi.getJournalEditionsForJournal({
			// 	journalId: journalId,
			// 	onlyId: true,
			// });

			journalEditions.items.forEach((journalEdition) => {
				//TODO try not to use the id in the path
				// let editionPath = trimJournalEditionTitle(journalEdition.fields.title);
				// editionPath = editionPath.trim();

				paths.push({
					params: {
						journal: journalName,
						editionDate: journalEdition.sys.id,
					},
				});
			});
		})
	);

	return {
		paths,
		fallback: "blocking",
	};
}

export async function getStaticProps({ params }) {
	const { journal, editionDate } = params;

	let journalId;
	if (journal === "jmpm") {
		journalId = Config.product.types.journal.JMPM.journalId;
	} else if (journal === "plj") {
		journalId = Config.product.types.journal.PLJ.journalId;
	} else if (journal === "fast-practice") {
		journalId = Config.product.types.journal.FAST_PRACTICE.journalId;
	} else if (journal === "halmj") {
		journalId = Config.product.types.journal.HALMJ.journalId;
	}
	//this should only return one journal edition
	let journalEditionArticles = [];
	const journalEdition = await ContentfulApi.queryIR({
		content_type: "journalEditions",
		links_to_entry: journalId,
		where: { "sys.id": editionDate },
		select: "sys.id,fields.editionDate,fields.title,fields.journalEditionVolume,fields.journalEditionIssue",
		// include: 1,
		// except: ["summary", "author", "bodyText", "primaryTag", "secondaryTag", "tertiaryTag", "journalEdition"],
	});
	if (journalEdition.items.length > 1) {
		console.error("There were too many editions returned by this query, fast-practice might do this");
	} else if (journalEdition.items.length < 1) {
		// console.error("There were no editions found");
		return {
			notFound: true,
			...(process.env.REVALIDATE_TIMER && { revalidate: process.env.REVALIDATE_TIMER }),
		};
	} else {
		journalEditionArticles = await ContentfulApi.getArticlesForJournalEditions({
			journalEditionId: journalEdition.items[0].sys.id,
		});

		//graphQL gives me back an undesirable date format, so it's updated here with what
		//the REST api returned
		journalEditionArticles.items.forEach((article) => {
			article.journalEdition.editionDate = journalEdition.items[0].fields.editionDate;
		});

		journalEditionArticles.items = journalEditionArticles.items.sort((a, b) => a.title.length - b.title.length);
	}

	// let data = await ContentfulApi.getPage("News Landing Page");

	return {
		props: {
			// data, //contentful page data
			additionalData: { productCollection: journalEditionArticles, journalEdition: journalEdition.items[0] },
		},
		...(process.env.REVALIDATE_TIMER && { revalidate: process.env.REVALIDATE_TIMER }),
	};
}
